console._method = function (msg) {
    console.log(
        '%c%s%s%s',
        'color:yellow; background-color:black;',
        ' – ',
        msg,
        ' – '
    );
};

console.focus = function (msg, object) {
    console.log(
        '%c%s%s%s',
        'color:brown; font-weight:bold; text-decoration:underline;',
        'Function: – ',
        msg,
        ' – '
    );
    if (object) {
        console.log(object);
    }
};
